import Link from "next/link";

import Loader from "../../../../Atoms/Loader";
import styles from "./TopGuides.module.scss";

import { gql, useQuery } from "@apollo/client";
import { Iso639 } from "../../../../../graphql/operations";
import AvailableGuidesCarousel from "../AvailableGuides/AvailableGuidesCarousel";

export default function TopGuides({ product }) {
  const { loading, error, data } = useQuery(GET_TOP_GUIDES, {
    variables: {
      productId: product.id,
      language: Iso639.En,
    },
  });

  if (loading) {
    return <Loader />;
  }

  if (error || !data || !data.guides) {
    return <>error</>;
  }

  const guides = data.guides.map((g) => {
    return { guide: g };
  });

  return (
    <>
      <div className={styles.TopGuidesContainer}>
        <AvailableGuidesCarousel
          title={"Top Guides"}
          availableGuides={guides}
          product={product}
        />

        <Link
          href={`/guide-listing/${product.id}?ref=top-guides`}
          target="_blank"
          className="ui-Link"
          style={{ textAlign: "center", width: "100%", marginTop: 20 }}
        >
          VIEW MORE GUIDES
        </Link>
      </div>
    </>
  );
}

export const GET_TOP_GUIDES = gql`
  query Guides($productId: ID, $language: Iso639!) {
    guides(
      input: {
        productId: $productId
        orderField: "numTours"
        offset: 0
        limit: 10
      }
    ) {
      id
      nickName
      introVideo
      profilePic
      translation(lang: $language) {
        description
      }
      numTours
      numCustomers
      reviews {
        totalRecords
        avgStars
      }
    }
  }
`;
